import { AxiosResponse } from "axios";

import { ContentExtractionApi, DAO_SESHAT } from "@/api/DAO";
import { FILES_URL } from "@/api/URL-constants";

import { AITutorFile } from "@/models/content-extraction.model";

const upload = (payload: FormData): Promise<void> => {
  return DAO_SESHAT().post(`${FILES_URL}/ai-tutor`, payload, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
const getAll = (
  productId: number
): Promise<AxiosResponse<{ data: AITutorFile[] }>> => {
  return DAO_SESHAT().get(`${FILES_URL}/ai-tutor/${productId}`);
};

const extractContent = (payload: { s3_folder_url: string }) => {
  return ContentExtractionApi().post(
    "/api/content-extraction/extract-content",
    payload
  );
};

export { upload, getAll, extractContent };
